import { User } from '@wellesley/openapi'
import { getRoute, normalizeAtPathForBrowser } from '@wellesley/router'
import { getDisplayUsername } from '@wellesley/user'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'

export const getSubtitle = (author: User) => {
  const groupName = author.groupName
  const groupUserName = author.groupUserName

  if (groupName && groupUserName !== author.username) {
    return normalizeAtPathForBrowser(
      getRoute(`/g/:groupname/@/:channelname/:tab?`, {
        groupname: groupName,
        channelname: groupUserName,
      }),
    )
  }

  return getDisplayUsername(getUserNameWithDomain(author))
}
